module.exports = __webpack_public_path__ + "img/location-gsl.e3597f9f.svg";